import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ConfigurationService {
  private setTimeoutDelay$$: BehaviorSubject<number> =
    new BehaviorSubject<number>(250);
  private httpsCallableTimeout$$: BehaviorSubject<number> =
    new BehaviorSubject<number>(60000);
  private listUsersMaxResults$$: BehaviorSubject<number> =
    new BehaviorSubject<number>(20);
  private showDebuggingInformation$$: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  private searchbarDebounce$$: BehaviorSubject<number> =
    new BehaviorSubject<number>(1000);
  private infiniteScrollTimeout$$: BehaviorSubject<number> =
    new BehaviorSubject<number>(1000);
  private teamLabel$$: BehaviorSubject<string> = new BehaviorSubject<string>(
    'Team'
  );
  private teamsLabel$$: BehaviorSubject<string> = new BehaviorSubject<string>(
    'Teams'
  );

  constructor() {}

  get setTimeoutDelay$() {
    return this.setTimeoutDelay$$.asObservable();
  }
  get setTimeoutDelay(): number {
    return this.setTimeoutDelay$$.getValue();
  }
  set setTimeoutDelay(delay: number) {
    this.setTimeoutDelay$$.next(delay);
  }
  get httpsCallableTimeout$() {
    return this.httpsCallableTimeout$$.asObservable();
  }
  get httpsCallableTimeout(): number {
    return this.httpsCallableTimeout$$.getValue();
  }
  set httpsCallableTimeout(timeout: number) {
    this.httpsCallableTimeout$$.next(timeout);
  }
  get showDebuggingInformation$() {
    return this.showDebuggingInformation$$.asObservable();
  }
  get showDebuggingInformation(): boolean {
    return this.showDebuggingInformation$$.getValue();
  }
  set showDebuggingInformation(showDebuggingInformation: boolean) {
    this.showDebuggingInformation$$.next(showDebuggingInformation);
  }

  get listUsersMaxResults$() {
    return this.listUsersMaxResults$$.asObservable();
  }
  get listUsersMaxResults(): number {
    return this.listUsersMaxResults$$.getValue();
  }
  set listUsersMaxResults(maxResults: number) {
    this.listUsersMaxResults$$.next(maxResults);
  }

  get searchbarDebounce(): number {
    return this.searchbarDebounce$$.value;
  }
  get infiniteScrollTimeout(): number {
    return this.infiniteScrollTimeout$$.value;
  }

  get teamLabel(): string {
    return this.teamLabel$$.value;
  }
  set teamLabel(label: string) {
    this.teamLabel$$.next(label);
  }

  get teamsLabel(): string {
    return this.teamsLabel$$.value;
  }
  set teamsLabel(label: string) {
    this.teamsLabel$$.next(label);
  }
}
